/**
 * Defines the format/state of the tile
 *
 * @remarks
 * These formats determine how the tile is visually presented and what metadata is displayed
 */
enum TileFormat {
  /** Standard video on demand content */
  VOD = "VOD",
  /** Content with playback progress indicator */
  ContinueWatching = "ContinueWatching",
  /** Scheduled upcoming content */
  Upcoming = "Upcoming",
  /** Currently live content */
  Live = "Live",
  /** Playlist or collection of content */
  Playlist = "Playlist",
  /** Collection/carousel tile */
  Collection = "Collection",
  /** Brand hub tile */
  Hub = "Hub",
  /** Short video clip */
  Clip = "Clip",
  /** Linear TV channels */
  Channel = "Channel",
  /** Replaycontent that was previously aired */
  Replay = "Replay",
  /** Linear TV content */
  Linear = "Linear",
}

enum providerLogoTheme {
  Dark = "Dark",
  Light = "Light",
  Default = "Default",
}

export { TileFormat, providerLogoTheme };
